import { LoadSpinner } from '@calizahq/react-components-v2'
import { WorkspaceView } from '@sales-app/context/workspace/workspace.type'
import { getWorkspacePath } from '@sales-app/context/workspace/workspace.util'
import { PeopleQueries } from '@sales-app/graphql/queries/people.queries'
import { BookablePersonType } from '@sales-app/types/BookablePersonType'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { NoResults } from '@/components'
import { useGraphql } from '@/hooks/useGraphql'

export const Screenpop = () => {
  const { search } = useLocation()
  const navigate = useNavigate()

  const type = new URLSearchParams(search).get('type') || ''
  const value = Number(new URLSearchParams(search).get('value')) || undefined

  const validType = type === 'member' || type === 'lead'

  const { data: bookablePersonData, isLoading } = useGraphql<PeopleQueries.GET_BOOKABLE_PERSON.Response>(
    PeopleQueries.getBookablePerson.name,
    PeopleQueries.getBookablePerson(),
    {
      bookablePersonRecord: {
        bookablePersonId: value,
        bookablePersonType: type === 'member' ? BookablePersonType.MEMBER : BookablePersonType.LEAD,
      },
    },
    {
      enabled: !!value && !!Number(value) && validType,
    },
  )

  if (bookablePersonData && bookablePersonData.bookablePerson) {
    const { bookablePersonId, bookablePersonType } = bookablePersonData.bookablePerson
    const path = getWorkspacePath({
      view: WorkspaceView.SUMMARY,
      type: bookablePersonType,
      id: bookablePersonId,
      potentialBookingId: null,
    })

    navigate(path)
  }

  return (
    <div className="flex w-full flex-col p-4 md:p-8">
      {isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          <NoResults />
        </>
      )}
    </div>
  )
}
